import { orgIfMemberById } from "./org-membership";

/**
 * Load an organization by ID. Membership check is enough for now
 * Roles will be checked at later points.
 * @param {string} orgId The ID of the organization
 * @param {string} userId The id of the user trying to access
 * @returns {object} The organization
 */
export async function loadOrganization(orgId, userId) {
  const org = await orgIfMemberById(orgId, userId);
  return org;
}
